import React from 'react';

const Navbar = () => {
    return (
        <div>
            {/* Component content */}
        </div>
    );
};

export default Navbar;